var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-grey-8 text-caption"},[_vm._t("default",[_vm._v("\n      "+_vm._s(_vm.label || '-')+"\n    ")])],2),_c('div',[_vm._t("value",[_vm._v("\n      "+_vm._s(_vm.value || '-')+"\n    ")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }